import { showInputError } from "../../../shared/input-handler";
export class CourseDates {
    constructor(datesWrapper, onDelete) {
        this.onDelete = onDelete;
        const dateRow = this.createDateRowFromTemplate();
        const dateRows = datesWrapper.querySelectorAll(CourseDates.dateRowSelector);
        if (dateRows.length === 0) {
            this.removeDeleteButton(dateRow);
        }
        else {
            this.addOnClickDeleteButton(dateRow, datesWrapper);
        }
        datesWrapper.appendChild(dateRow);
        this.start = dateRow.querySelector(CourseDates.startDateSelector);
        this.end = dateRow.querySelector(CourseDates.endDateSelector);
        this.enrollmentDeadline = dateRow.querySelector(CourseDates.enrollmentDeadlineSelector);
    }
    addToFormData(formData) {
        formData.append(this.start.name, this.start.value);
        formData.append(this.end.name, this.end.value);
        formData.append(this.enrollmentDeadline.name, this.enrollmentDeadline.value);
    }
    validate() {
        let valid = this.ensureHasValue(this.start);
        valid = valid && this.ensureHasValue(this.end);
        valid = valid && this.ensureHasValue(this.enrollmentDeadline);
        return valid;
    }
    createDate(dateString) {
        const date = new Date(dateString.replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1"));
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date format");
        }
        return date;
    }
    createDateRowFromTemplate() {
        const dateTemplate = document.getElementById(CourseDates.datesTemplateId);
        let dateRow = null;
        if (dateTemplate) {
            dateRow = document
                .importNode(dateTemplate.content, true)
                .querySelector(CourseDates.dateRowSelector);
        }
        if (!dateRow) {
            throw new Error("Date row not found inside template");
        }
        return dateRow;
    }
    addOnClickDeleteButton(dateRow, datesWrapper) {
        dateRow
            .querySelector(CourseDates.removeDatesSelector)
            .addEventListener("click", () => {
            datesWrapper.removeChild(dateRow);
            this.onDelete(this);
        });
    }
    removeDeleteButton(dateRow) {
        dateRow.querySelector(CourseDates.removeDatesSelector).remove();
    }
    ensureHasValue(input) {
        if (!input.value) {
            showInputError(input, requiredField);
            return false;
        }
        return true;
    }
}
CourseDates.datesWrapperSelector = ".js-dates";
CourseDates.datesTemplateId = "dates-template";
CourseDates.removeDatesSelector = ".js-remove-dates";
CourseDates.startDateSelector = "input.js-start-date";
CourseDates.endDateSelector = "input.js-end-date";
CourseDates.enrollmentDeadlineSelector = "input.js-enrollment-deadline";
CourseDates.dateRowSelector = ".js-dates-row";
